import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetworkUtilsService {
  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    });
  }

  headers: HttpHeaders = new HttpHeaders();

  private addToDefaultHeaders(headers?: HttpHeaders) {
    if (headers?.keys().length) {
      for (let i = 0; i < headers?.keys().length; i++) {
        this.headers = this.headers.set(
          headers?.keys()[i],
          headers.get(headers?.keys()[i])!,
        );
      }
    }
  }

  get<T>(url: string, headers?: HttpHeaders) {
    this.addToDefaultHeaders(headers);
    return this.http.get(url, { headers: this.headers }) as Observable<T>;
  }

  post<T>(url: string, requestBody?: unknown, headers?: HttpHeaders) {
    this.addToDefaultHeaders(headers);
    return this.http.post(url, requestBody, {
      headers: this.headers,
    }) as Observable<T>;
  }
}

//TODO create separate handler for portal
const APP_BASE_ROUTE = '/app/';
const V2 = 'v2/';
const ADMIN_BASE_ROUTE = '/admin/';
const PHYSICAL_FITNESS_ROUTE = 'physical-fitness/';
const LYFIS_BASE_ROUTE = 'lyfis/';

export class URL_DICT {
  public static sessionSyncMeetParticipantDataUrl =
    environment.apiBackendBaseUrl + '/admin/session/meet-data/sync';
  public static adminSessionBase =
    environment.apiBackendBaseUrl + '/admin/session/';
  public static sessionRewards =
    environment.apiBackendBaseUrl + '/admin/session/reward/grid';
  public static logoutUrl = environment.apiBackendBaseUrl + '/auth/logout';
  public static updateAdminTherapistEmailUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'therapist/update-email';
  public static sessionExpertAddRemark =
    environment.apiBackendBaseUrl + '/admin/session/add/remark';
  public static getMasterData =
    environment.apiBackendBaseUrl + '/' + 'master-data';
  public static getLyfisMasterData =
    environment.apiBackendBaseUrl + '/' + 'lyfis-master-data';
  public static getMasterDataPartners =
    environment.apiBackendBaseUrl + '/' + 'master-data-partners';
  public static getUserInterestsMeta =
    environment.apiBackendBaseUrl + '/user-interests';
  public static getUserByEmail =
    environment.apiBackendBaseUrl + '/' + 'getUserByEmail';
  public static generateOtpUrl =
    environment.apiBackendBaseUrl + '/auth/generateotp';
  public static verifyOtpUrl =
    environment.apiBackendBaseUrl + '/auth/verifyotp';
  public static getListenerByEmail =
    environment.apiBackendBaseUrl + '/listener/getListenerByEmail';
  public static getPendingChatSummary =
    environment.apiBackendBaseUrl + '/chat/pending/summary';
  public static postChatSummary =
    environment.apiBackendBaseUrl + '/chat/summary';
  public static getChatSummary =
    environment.apiBackendBaseUrl + '/chat/completed/summary';
  public static acceptChat = environment.apiBackendBaseUrl + '/chat/acceptChat';
  public static listenerLastSeenUrl =
    environment.apiBackendBaseUrl + '/listener/stamp/';
  public static resetPassword =
    environment.apiBackendBaseUrl + '/auth/reset-password';
  public static partnerGrid =
    environment.apiBackendBaseUrl + '/admin/partner/grid';
  public static memberGrid =
    environment.apiBackendBaseUrl + '/admin/members/grid/';
  public static memberGridStats =
    environment.apiBackendBaseUrl + '/admin/members/grid/stats/';
  public static adminSessionGrid =
    environment.apiBackendBaseUrl + '/admin/sessions/grid';
  public static therapist = environment.apiBackendBaseUrl + '/admin/therapist/';
  public static listener = environment.apiBackendBaseUrl + '/admin/listener/';
  public static partner = environment.apiBackendBaseUrl + '/admin/partner/';
  public static member = environment.apiBackendBaseUrl + '/admin/member/';
  public static transferMember =
    environment.apiBackendBaseUrl + '/admin/member/transfer';
  public static subscription =
    environment.apiBackendBaseUrl + '/admin/subscription/';
  public static adminSessionFeedBack =
    environment.apiBackendBaseUrl + '/admin/session/feedback';
  public static supportPortal =
    environment.apiBackendBaseUrl + '/portal/therapist/';
  public static adminSearchUsers =
    environment.apiBackendBaseUrl + '/admin/users';
  public static getActiveTherapists =
    environment.apiBackendBaseUrl + APP_BASE_ROUTE + 'therapists';
  public static getAvailableSlots =
    environment.apiBackendBaseUrl + '/admin/therapist/slots/';
  public static adminSessionBooking =
    environment.apiBackendBaseUrl + '/admin/session/newbooking';
  public static adminSessionPacksBooking =
    environment.apiBackendBaseUrl + '/admin/session/packs/newbooking';
  public static adminGetUploadUrl =
    environment.apiBackendBaseUrl + '/admin/upload';
  public static adminGetNewContentId =
    environment.apiBackendBaseUrl + '/admin/content/newid';
  public static adminNewContentPostHandler =
    environment.apiBackendBaseUrl + '/admin/content';
  public static adminContentUrl =
    environment.apiBackendBaseUrl + '/admin/content';
  public static contentGrid =
    environment.apiBackendBaseUrl + '/admin/content/grid';
  public static adminRoutineUrl =
    environment.apiBackendBaseUrl + '/admin/routine';
  public static adminSessionUpdateUrl =
    environment.apiBackendBaseUrl + '/admin/session/update';
  public static adminSessionCancelUrl =
    environment.apiBackendBaseUrl + '/admin/session/cancel';
  public static adminSessionConfirmUrl =
    environment.apiBackendBaseUrl + '/admin/session/confirm';
  public static adminSessionRescheduledDeclineUrl =
    environment.apiBackendBaseUrl + '/admin/session/reschedule/decline';
  public static adminSessionOverrideStatusUrl =
    environment.apiBackendBaseUrl + '/admin/sessions/';
  public static adminCheckSlotsAvailableUrl =
    environment.apiBackendBaseUrl + '/admin/therapist/meta/';
  public static adminCanMakeTherapistVisibleUrl =
    environment.apiBackendBaseUrl + '/admin/therapists/can-visible';
  public static adminContentsByCategory =
    environment.apiBackendBaseUrl + '/admin/contentsByCategory';
  public static adminRoutineGridUrl =
    environment.apiBackendBaseUrl + '/admin/grid/routine/';
  public static adminRoutineEnableDisableUrl =
    environment.apiBackendBaseUrl + '/admin/routine/availability/';
  public static adminBytesCategoryUrl =
    environment.apiBackendBaseUrl + '/admin/bytesCategory/';
  public static adminBytesCategoriesGridUrl =
    environment.apiBackendBaseUrl + '/admin/bytesCategory/grid';
  public static adminAddNewBytesUrl =
    environment.apiBackendBaseUrl + '/admin/bytes/new';
  public static adminBytesGridUrl =
    environment.apiBackendBaseUrl + '/admin/bytes/grid';
  public static adminGetByteUrl =
    environment.apiBackendBaseUrl + '/admin/bytes/';
  public static adminUpdateByteUrl =
    environment.apiBackendBaseUrl + '/admin/bytes/';
  public static adminAddNewBytesBulkUrl =
    environment.apiBackendBaseUrl + '/admin/bytes/new/bulk';
  public static reportBugUrl =
    environment.apiBackendBaseUrl + APP_BASE_ROUTE + 'bug/report';
  public static adminCircles =
    environment.apiBackendBaseUrl + '/admin/circles/';
  public static adminPostsUrl =
    environment.apiBackendBaseUrl + '/admin/circles/post/create';
  public static postsMediaUploadUrl =
    environment.apiBackendBaseUrl + '/admin/circles/media/upload';
  public static adminCirclePostsGrid =
    environment.apiBackendBaseUrl + '/admin/circles/posts/grid';
  public static adminCirclePostReportsGrid =
    environment.apiBackendBaseUrl + '/admin/circles/post/reports/grid';
  public static adminCirclePostModeratorActions =
    environment.apiBackendBaseUrl + '/admin/circles/post/actions';
  public static adminCirclePostGet =
    environment.apiBackendBaseUrl + '/admin/circles/posts/';
  public static adminCirclesGetUrl =
    environment.apiBackendBaseUrl + '/admin/circles/masterdata/get';
  public static adminBulkSendCorporateCode =
    environment.apiBackendBaseUrl + '/admin/members/bulksend';
  public static adminBulkUploadMembers =
    environment.apiBackendBaseUrl + '/admin/members/bulkupload/';
  public static adminRolesAndPermissionTableUrl =
    environment.apiBackendBaseUrl + '/super-admin/user/roles';
  public static adminRolesAndPermissionsUrl =
    environment.apiBackendBaseUrl + '/super-admin/roles-permissions/get';
  public static adminAddRolesAndPermissionsUrl =
    environment.apiBackendBaseUrl + '/super-admin/roles-permissions/add';
  public static adminUserCreateUrl =
    environment.apiBackendBaseUrl + '/super-admin/create';
  public static adminEnableDisableUserInAllCollectionUrl =
    environment.apiBackendBaseUrl + '/super-admin/user/availability';
  public static adminGetTimeRanges =
    environment.apiBackendBaseUrl + '/admin/therapist/slot/time-ranges';
  public static adminMarkNotAvailableSlot =
    environment.apiBackendBaseUrl + '/admin/therapist/mark/not-available';
  public static getTherapistByEmailUrl =
    environment.apiBackendBaseUrl + '/admin/therapist/get/';
  public static eventsGridUrl =
    environment.apiBackendBaseUrl + '/admin/events/grid';
  public static eventsGetUrl = environment.apiBackendBaseUrl + '/admin/events/';
  public static adminCreateOrUpdateEvent =
    environment.apiBackendBaseUrl + '/admin/events/upsert';
  public static eventsRegistrationGridUrl =
    environment.apiBackendBaseUrl + '/admin/events/registrations/grid';
  public static talksAdminGridUrl =
    environment.apiBackendBaseUrl + '/admin/talks/grid';
  public static talkSetPlaybackUrl =
    environment.apiBackendBaseUrl + '/admin/talks/setSession';
  public static talksLogAdminGridUrl =
    environment.apiBackendBaseUrl + '/admin/talks/talkLogs/grid';
  public static fetchBroadCastDetailsTalks =
    environment.apiBackendBaseUrl + '/admin/talks/broadcastDetails';
  public static addParticipant =
    environment.apiBackendBaseUrl + '/app/talks/addParticipant';
  public static updateTalkNotificationDetails =
    environment.apiBackendBaseUrl + '/admin/talks/updateNotification';
  public static getTalkDetailsById =
    environment.apiBackendBaseUrl + '/admin/talks/';
  public static getPartnerByUser =
    environment.apiBackendBaseUrl + '/partner/getPartnerByUser';
  public static fetchPartnerMemberGrid =
    environment.apiBackendBaseUrl + '/partner/members/grid';
  public static partnerPortalAddMember =
    environment.apiBackendBaseUrl + '/partner/members/add';
  public static partnerPortalBulkAddMember =
    environment.apiBackendBaseUrl + '/partner/members/bulk/add/';
  public static partnerPortalBulkInviteMember =
    environment.apiBackendBaseUrl + '/partner/members/bulk/invite';
  public static partnerPortalDeleteMember =
    environment.apiBackendBaseUrl + '/partner/members/delete';
  public static partnerPortalResetPassword =
    environment.apiBackendBaseUrl + '/partner/reset-password';
  public static sessionStatsUrl =
    environment.apiBackendBaseUrl + '/admin/session/stats';
  public static userProfileSearchUrl =
    environment.apiBackendBaseUrl + '/admin/user/profile';
  public static userUpdateUserProfileUrl =
    environment.apiBackendBaseUrl + '/admin/user/update-profile/';
  public static userUpdateUserEmailUrl =
    environment.apiBackendBaseUrl + '/admin/user/update-email/';
  public static userEmailAuditLogUrl =
    environment.apiBackendBaseUrl + '/admin/user/email-audit-log/';
  public static adminRetryUserLabReportsProcessingUrl =
    environment.apiBackendBaseUrl + '/admin/labReports/retry/user';
  public static callToUserUrl =
    environment.apiBackendBaseUrl + '/admin/call/admintouser';
  public static createTherapyPlanUrl =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/add';
  public static fetchTherapyPlans =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/fetch';
  public static linkTherapyPlanUrl =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/link';
  static unLinkTherapyPlanUrl =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/un-link';
  public static adminTherapyPlansGrid =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/grid/all';
  public static adminTherapyPlanGetUrl =
    environment.apiBackendBaseUrl + '/admin/therapist/plan/';
  public static adminTherapyPlanUpdateUrl =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/';
  public static adminTherapyPlansSubcriptionGrid =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/subscription/grid';
  public static adminFetchPlanForConcerns =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/fetch/concern';
  public static adminActivateTherapyPlan =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/activate';
  public static adminExpertsGrid =
    environment.apiBackendBaseUrl + '/admin/experts/grid';
  public static adminExpertsTherapistListenerCreate =
    environment.apiBackendBaseUrl + '/admin/experts/add';
  public static adminExpertsGet =
    environment.apiBackendBaseUrl + '/admin/experts/';
  public static adminExpertsClients =
    environment.apiBackendBaseUrl + '/admin/experts/clients/grid';
  public static adminUniqueUserTherapySubs =
    environment.apiBackendBaseUrl + '/admin/therapy/plan/sub/unique/';
  public static adminAddExtraSessionsToPlanSubs =
    environment.apiBackendBaseUrl + '/admin/add/extra/session/plan/subs/';
  public static adminFetchPlanForUser =
    environment.apiBackendBaseUrl + '/admin/therapist/plans/user';
  public static adminFetchPackForUser =
    environment.apiBackendBaseUrl + '/admin/therapist/packs/user';
  public static adminAddUserFormAttributes =
    environment.apiBackendBaseUrl + '/admin/add/userformattributes';
  public static adminGetUserFormAttributes =
    environment.apiBackendBaseUrl + '/admin/get/userformattributes';
  public static adminUpdateUserFormAttributes =
    environment.apiBackendBaseUrl + '/admin/update/userformattributes';
  public static adminTherapistAVailabilityV2Url =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    V2 +
    'therapist/availability';
  public static getClubPass =
    environment.apiBackendBaseUrl + '/admin/club-pass/get';
  public static adminExpertOnboardRequestGridUrl =
    environment.apiBackendBaseUrl + '/admin/expert-onboarding/grid';
  public static adminExpertOnboardRequestGetUrl =
    environment.apiBackendBaseUrl + '/admin/expert-onboarding/get/';
  public static adminExpertOnboardReqAddComments =
    environment.apiBackendBaseUrl + '/admin/expert/onboard/comments/';
  public static adminExpertOnboardReqStatusUpdate =
    environment.apiBackendBaseUrl + '/admin/expert/onboard/status/';
  public static adminExpertOnboardPdfDownLoadUr =
    environment.apiBackendBaseUrl + '/admin/expert/onboard/media/download';

  //rewards
  public static adminGetRewardsValues =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'reward-values/get';
  public static adminUpdateRewardsValues =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'add/reward-values';
  public static adminRewardGrid =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'reward/grid ';
  public static adminMakePayment =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'rewards/make-payout/';
  public static addRewardToLedger =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'reward/manual/adjustment/';
  public static getAmountForPayment =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'reward/get/amount-for-payout/';
  public static adminConsolidateRewardsExport =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'rewards/consolidate-export';

  //promo-code
  public static adminPromoCodeCreateUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'promo-code';
  public static adminPromoCodeGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'promo-code/grid';

  //survey
  public static adminSurveyCreateUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'survey/add';
  public static adminSurveysGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'surveys';
  public static adminSurveyResponsesGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'survey/responses';
  public static adminTherapistsTransferGetUrl =
    environment.apiBackendBaseUrl + '/admin/therapists/transfer';
  public static adminTherapistTransferPostUrl =
    environment.apiBackendBaseUrl + '/admin/therapists/transfer/subscription';
  public static adminSendSessionFeedbackDocumentUrl =
    environment.apiBackendBaseUrl + '/admin/therapists/session-feedback/send';

  //events bidding
  public static adminAddOrUpdateEventsBidding =
    environment.apiBackendBaseUrl + '/admin/events/bidding/create';
  public static adminGetEventsBidding =
    environment.apiBackendBaseUrl + '/admin/events/bidding/get/';
  public static adminEventsBidsGridUrl =
    environment.apiBackendBaseUrl + '/admin/events/bidding/grid';
  public static adminEventsBidsLogGridUrl =
    environment.apiBackendBaseUrl + '/admin/events/bidding/log/grid';
  public static adminAcceptOrRejectBid =
    environment.apiBackendBaseUrl + '/admin/events/bidding/action';

  //packs
  public static adminPacksCreateUrl =
    environment.apiBackendBaseUrl + '/admin/pack/create';
  public static adminPacksGetUrl =
    environment.apiBackendBaseUrl + '/admin/pack/';
  public static adminPacksGridUrl =
    environment.apiBackendBaseUrl + '/admin/pack/grid';
  public static adminPacksSubscriptionGridUrl =
    environment.apiBackendBaseUrl + '/admin/pack/subscription/grid';
  public static adminActivatePackSubscriptionUrl =
    environment.apiBackendBaseUrl + '/admin/packs/activate';
  public static adminDeactivatePackSubscriptionUrl =
    environment.apiBackendBaseUrl + '/admin/packs/deactivate';
  public static adminTransferTherapistPackSubscriptionUrl =
    environment.apiBackendBaseUrl + '/admin/packs/transfer';
  public static adminChangeAuxTherapist =
    environment.apiBackendBaseUrl + '/admin/packs/change/auxtherapist';
  public static adminGetPromptLLMTemplate =
    environment.apiBackendBaseUrl + '/admin/packs/chat/templates';
  public static adminTestPromptLLMTemplate =
    environment.apiBackendBaseUrl + '/admin/packs/chat/test';

  //fitness challenges
  public static adminfitnessChallengeCreateUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    PHYSICAL_FITNESS_ROUTE +
    'challenge/create';
  public static adminfitnessChallengeUpdateUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    PHYSICAL_FITNESS_ROUTE +
    'challenge/update/';
  public static adminfitnessExercisesAllUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    PHYSICAL_FITNESS_ROUTE +
    'exercises';
  public static adminfitnessChallengesGetUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    PHYSICAL_FITNESS_ROUTE +
    'challenges';
  public static adminFitnessLogsGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'grid/fitness-logs';

  public static adminConvertCorporateToRetail =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'corporate-to-retail';

  public static adminDeactivedPlan =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'therapist/plans/hide';
  public static adminBlockPlan =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'therapist/plans/block';

  //gallabox whatsapp
  public static adminWhatsappTemplatelistUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'whatsapp-templates';
  public static adminSendWhatsappMessageUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'whatsapp/send-message';
  //add vertical concern admin
  public static adminAddVerticalUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'masterdata/vertical/add';
  public static adminAddConcernUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'masterdata/concern/add';
  public static adminGetVerticalConcernUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'masterdata/vertical-concern/get';
  public static getSessionalTagUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'masterdata/get/sessionaltags';
  public static addSessionalTagUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'seasonalTags/add';

  //email-templates-for-partners
  public static emailTesting =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'test-email';
  public static addEmailTemplateUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'email-templates/add';
  public static getEmailTemplateTagsUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'email-templates/tags';
  public static emailTemplatesGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'email-templates/grid';
  public static emailTemplateGetUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'email-templates/';
  public static emailTemplateHistoryGetUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'email-templates/history/grid';
  public static emailTemplateUpdatePostUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'email-templates/update/';

  public static blockUserSessionBookingUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'user/block-session-booking';
  public static unBlockUserSessionBookingUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'user/unblock-session-booking';

  public static fixMemberPassRedemptionUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'member/fix-redemption';

  public static whitelistedDomainsUrl =
    environment.apiBackendBaseUrl + APP_BASE_ROUTE + 'u/whitelisted-domains';

  public static adminTherapistFeedbackUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'feedback-therapist/grid';
  public static adminAnyoEventsFeedbackUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'feedback-events/grid';
  public static addEventRegistrationUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'events/bulkupload/registration';

  //campaign
  public static adminCampaignUpsertUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'campaign/upsert';
  public static adminCampaignGetUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'campaign/';
  public static adminCampaignGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'campaigns/grid';
  public static adminMasterDataConfigCreate =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'masterDataConfig/create';
  public static adminMasterDataConfigGetAll =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'masterDataConfig/getAll';
  public static adminMasterDataConfigByCategory =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'masterDataConfig/';
  public static adminMasterDataCreate =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'masterdata/create';
  public static adminMasterDataListByCategory =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'masterdata/';
  public static adminMasterDataExpertList =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'list/allexperts';
  public static adminCheckAnyIdGetName =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'masterdata/check-id';
  public static adminMasterDataCategoryGetUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'masterdata/categories/get';
  // rule engine
  public static adminRuleEngineCreateUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'rule-engine/create';
  public static adminRuleEngineGetUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'rule-engine/get/';
  public static adminRuleEngineGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'rule-engine/grid';

  // Anyo Goals admin panel (APH-4995)
  public static adminGoalsUserLifecycleUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'goals/user/';
  public static adminGoalsPauseUrl = (userId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/user/' +
    userId +
    '/pause';
  public static adminGoalsResumeUrl = (userId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/user/' +
    userId +
    '/resume';
  public static adminGoalsAbandonUrl = (userId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/user/' +
    userId +
    '/abandon';
  public static adminGoalsChangeExpertUrl = (userId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/user/' +
    userId +
    '/change-expert';
  public static adminGoalsMarkDayCompleteUrl = (userObjectiveId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/user-objectives/' +
    userObjectiveId +
    '/mark-day-complete';
  public static adminGoalsPlanProgressorMonitorGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/plan-progressor-monitor/grid';
  public static adminGoalsObjectivesGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'goals/objectives/grid';
  public static adminGoalsUserObjectivesGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/user-objectives/grid';
  public static adminGoalsRetireObjectiveUrl = (objectiveId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/objectives/' +
    objectiveId +
    '/retire';
  public static adminGoalsRetireUserObjectiveUrl = (userObjectiveId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/user-objectives/' +
    userObjectiveId +
    '/retire';
  public static adminGoalsGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'goals/grid';
  public static adminGoalsForceRecalcUrl = (userId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/user/' +
    userId +
    '/force-recalc';
  public static adminGoalsUnassignedReferralsGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/referrals/unassigned/grid';
  public static adminGoalsAssignExpertToReferralUrl = (referralId: string) =>
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'goals/referrals/' +
    referralId +
    '/assign-expert';

  // Anyo Forum

  public static adminCreateOrUpdateForum =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'forums/upsert';
  public static forumGetUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'forums/';
  public static forumGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'forums/grid';

  // lyfis scorecard compiler
  public static lyfisScorecardUploadUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    LYFIS_BASE_ROUTE +
    'scorecards/upload-url';
  public static lyfisScorecardUploadStatusUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    LYFIS_BASE_ROUTE +
    'scorecards/upload-status';
  public static lyfisScorecardCompileChatUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    LYFIS_BASE_ROUTE +
    'scorecards/';
  public static lyfisScorecardGetUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    LYFIS_BASE_ROUTE +
    'scorecards/';
  public static lyfisScorecardGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    LYFIS_BASE_ROUTE +
    'scorecards/grid';
  // lyfis
  public static adminLyfisDropdownValuesUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'lyfis/dropdown-values';
  public static forumRegistrationsGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'forums/registrations/grid';
  public static addForumRegistrationUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'forums/bulkupload/registration';
  public static adminLyfisPartnerProfilesUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'lyfis/partner-profiles';
  public static adminLyfisPartnerProfileDiseaseRequirementsUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'lyfis/partner-profiles';
  public static adminLyfisPartnerProfilesGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'lyfis/partner-profiles/grid';
  public static adminLyfisQuestionsGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'lyfis/questions/grid';
  public static adminLyfisQuestionsUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'lyfis/questions';
  public static adminLyfisViewScoresUsersGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'lyfis/view-scores/users/grid';
  public static adminLyfisViewScoresUserSnapshotsGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'lyfis/view-scores/users/';
  public static adminLyfisViewScoresSnapshotDiseasesGridUrl =
    environment.apiBackendBaseUrl +
    ADMIN_BASE_ROUTE +
    'lyfis/view-scores/snapshots/';

  // policy
  public static adminPolicyContractUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/contract/';
  public static adminPolicyRulesUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/rules';
  public static adminPolicyTherapistFilterRulesUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/therapist-filter-rules';
  public static adminPolicyVisibilityUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/visibility/';
  public static adminPolicyBenefitsUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/benefits/';
  public static adminPolicyGlobalRulesUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/global-rules';
  public static adminPolicyRuleDescribeUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/rules/';
  public static adminPolicyDebugUserUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/debug/user';
  public static adminPolicyUserRulesUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'policy/user-rules';
  public static adminUserExpertChatsBaseUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'user/';

  // reengage audit
  public static adminReengageAuditGridUrl =
    environment.apiBackendBaseUrl + ADMIN_BASE_ROUTE + 'reengage/audit/grid';
}
